import { render, staticRenderFns } from "./addInstruct.vue?vue&type=template&id=5b39cd4f&scoped=true&"
import script from "./addInstruct.vue?vue&type=script&lang=js&"
export * from "./addInstruct.vue?vue&type=script&lang=js&"
import style0 from "./addInstruct.vue?vue&type=style&index=0&id=5b39cd4f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b39cd4f",
  null
  
)

export default component.exports